import { Component, OnInit } from '@angular/core';
import { Photo, PhotoGallerySettings } from '../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes';
import { TripEntry } from '../../widgets-module/components/trip-list/trip-list.component';
import {Router} from "@angular/router";

@Component({
  selector: 'app-tipping-guide',
  templateUrl: './tipping-guide.component.html',
  styleUrls: ['./tipping-guide.component.css']
})
export class TippingGuideComponent implements OnInit {

  tripEntriesSafari: TripEntry[] = [
    new TripEntry({title: 'Big Buck Safari', route: '../../safari/big-buck-safari', iconName: 'buffalo'}),
    new TripEntry({title: 'Culture Quest', route: '../../safari/culture-quest-safari', iconName: 'drum'}),
    new TripEntry({title: 'Lion\'s Share', route: '../../safari/lions-share-safari', iconName: 'lion'})
  ];

  tripListSubtitle = 'Browse available Kilimanjaro Trek Routes!';
  tripListTitle = 'Packed your gear and ready to go?';


  tripEntriesKilimanjaro = [
    new TripEntry({title: 'Machame Route', route: '/kilimanjaro/machame-route'}),
    new TripEntry({title: 'Lemosho Route', route: '/kilimanjaro/lemosho-route'}),
    new TripEntry({title: 'Marangu Route', route: '/kilimanjaro/marangu-route'})
  ];

  safariTruckGallery: PhotoGallerySettings = new PhotoGallerySettings ( {
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Mountain Crew',
          description: 'A good climbing crew is key to your summit success.',
          thumbnailPath: '700x525/kopa-climb-crew-sm.jpg',
          highresPath: '../../assets/img/others/kopa-climb-crew.jpg',
          altPhotoDescription: 'Kopa Tours - Kilimanjaro Mountain Crew.'
        })
      ]
    } );

    porterGallery: PhotoGallerySettings = new PhotoGallerySettings ( {
      iconColor: 'dark',
      photos:
        [
          new Photo({
            title: 'World Class Safari Guides',
            description: 'Our lead guide Mohamed won Tour Guide of the Year 2020, Tanzania',
            thumbnailPath: 'others/madeal-simba.jpg',
            highresPath: '../../assets/img/others/madeal-simba.jpg',
            altPhotoDescription: 'Mohamed Abdalah - Best Safari Guide 2020.'
          })
        ]
      } );

  constructor(private router: Router) { }

  ngOnInit() {
  }

  isBasePage() {
    return this.router.url.indexOf('#') === -1;
  }

}
